module.exports = __webpack_public_path__ + "img/IMG_5615_P-2_L_Wood.bbdeb6ae.jpg";